class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);

/* Tab counts (spec 10: "Products 34 / Stories 4"). Liquid only knows the
   count for the type being viewed, so the other tab ships an empty count span
   and is hydrated here from the Section Rendering API — the same section
   rendered per type, reading the number Liquid printed into the active tab.
   Progressive enhancement: one shot, and a failed fetch just leaves the span
   empty (CSS hides empty spans) — never a stale or guessed number. */
(() => {
  const hydrate = () => {
    const nav = document.querySelector('.kashira-search-tabs[data-section-id]');
    if (!nav) return;
    nav.querySelectorAll('.kashira-search-tabs__count').forEach((span) => {
      if (span.textContent.trim() !== '') return;
      const type = span.dataset.kashiraCount;
      const params = new URLSearchParams({
        q: nav.dataset.terms || '',
        type,
        section_id: nav.dataset.sectionId,
      });
      params.set('options[prefix]', 'last');
      fetch(`${window.routes?.search_url || '/search'}?${params}`)
        .then((r) => (r.ok ? r.text() : Promise.reject()))
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const count = doc.querySelector(`.kashira-search-tabs__count[data-kashira-count='${type}']`);
          const value = count && count.textContent.trim();
          if (value) span.textContent = value;
        })
        .catch(() => {});
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate);
  } else {
    hydrate();
  }
})();
